import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  width: 100%;
  padding: 100px 0 165px 0;
  display: flex;
  .AreaInfo_media {
    margin: 0 0 15px 0;
    img {
      width: 100%;
      height: auto;
    }
  }
  .AreaInfo_content {
    @media (min-width: 992px) {
      margin-left: 50px;
    }
  }
  .AreaInfo_title {
    font-weight: 200;
    font-size: 54px;
    color: ${colors.color1};
    font-family: ${typography.Serif};
    margin: 20px 0 60px 0;
    position: relative;
    &:after {
      content: '';
      display: block;
      width: 200px;
      height: 3px;
      position: absolute;
      bottom: -30px;
      left: 0;
      background-color: ${colors.color2};
    }
    @media (min-width: 992px) {
      font-size: 72px;
    }
  }
  .AreaInfo_postTitle {
    font-size: 18px;
    margin-top: 10px;
    color: ${colors.color5};
    display: block;
    @media (min-width: 992px) {
      margin-top: 15px;
      font-size: 18px;
      line-height: 1.5;
    }
  }
  .AreaInfo_body {
    font-weight: 300;
    font-size: 19px;
    line-height: 22px;
    color: ${colors.color5};
  }
`;

function AreaInfo({ page }) {
  return (
    <div className={styles}>
      <div className="AreaInfo_wrapper container">
        <div className="AreaInfo_inner row">
          <div className="AreaInfo_media col-lg-6">
            <img src={get(page, 'area_info[0].image.contentUrl')} alt={get(page, 'area_info[0].image.alt')} />
          </div>
          <div className="AreaInfo_content col-lg-5">
            <h3 className="AreaInfo_title">
              Affordable Luxury <span className="AreaInfo_postTitle">Throughout the {get(page, 'area_info[0].area_name')} Area</span>
            </h3>
            <div className="AreaInfo_body" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'area_info[0].description'))} />
          </div>
        </div>
      </div>
    </div>
  );
}

AreaInfo.propTypes = {
  page: PropTypes.object.isRequired,
};

export default AreaInfo;



// WEBPACK FOOTER //
// ./src/pages/Communities/AreaInfo.js